import { Box, Button, Typography } from '@mui/material/';
import { useMemo } from 'react';
import { ArticlesProps } from '../../interfaces/props/ArticlesProps';
import classes from '../articles/Articles.module.scss';
import ArticleCard from '../../components/article-card/ArticleCard';
import TagsService from '../../services/tags.service';
import URLHelper from '../../helpers/url.helper';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../../../store/filters/filters.slice';
import ClearIcon from '@mui/icons-material/Clear';
import DetectMobileHelper from '../../helpers/detect-mobile.helper';

const notFoundByFiltersMessage: string =
  'It looks like there is no content for the selected criteria. Please clear filters or choose other categories';

const Articles = ({ articles, areFiltersEmpty, loading }: ArticlesProps) => {
  const dispatch = useDispatch();

  const articlesRender = useMemo(() => {
    const handleClearFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
      dispatch(resetFilters());
    }

    if (articles.length === 0 && !areFiltersEmpty && !loading) {
      return (
        <Box>
          <Box
            className={`${classes['message-placeholder']} text-center d-flex justify-content-center align-items-center px-2`}
          >
            {notFoundByFiltersMessage}
          </Box>
          {DetectMobileHelper.isMobile() && (
            <Box className='border pt-1 mt-4 rounded' textAlign='center'>
              <Button
                className={classes.button}
                onClick={handleClearFilters}
              >
                <ClearIcon fontSize='small' />
                <Typography className='text-btn-primary'>
                  Clear All Filters
                </Typography>
              </Button>
            </Box>
          )}
        </Box>
      );
    }

    return articles.map((article) => (
      <Box key={article.getId()} className='mb-4'>
        <ArticleCard
          id={article.getId()}
          title={article.getHeadlinesEnglish()}
          summary={article.getProcessedContent()}
          image={article.getAssets()}
          createdAt={article.getPostCreatedAt() ?? article.getCreatedAt()}
          siteName={URLHelper.getDomainName(article.getSiteUrl())}
          source={article.getUrl()}
          tags={TagsService.clearNoTagTags(article.getTags())}
          facts={article.getFacts()}
          tipsAndPredictions={article.getTipsAndPredictions()}
          tvChannels={article.getTvChannels()}
          type={{ name: article.getTypeName(), id: article.getTypeId() }}
          numberOfWords={article.getNumberOfWords()}
        />
      </Box>
    ));
  }, [articles, areFiltersEmpty, loading, dispatch]);

  return (
    <Box className={`pt-2`}>
      {articlesRender}
    </Box>
  );
};

export default Articles;
